import type { ComparisonOperator, LogicalOperator, HeliosRecordSystemDatasource, ConditionValueSource } from './dataHelios';
import type { BasePagedResponse, BasicFilter } from './api';

// Enums for user filter types - must match backend values
export enum EUserFilterType {
  Template = 1,
  Administration = 2,
  Empty = 3,
}

export enum EUserFilterAdministrationSectionType {
  None = 0,
  Listing = 1,
  Detail = 2,
}

// Condition types
export interface HeliosUserFilterConditionDatasource {
  templateDataItemId?: number;
  aggregationGroupId?: string | null;
  systemDatasource?: HeliosRecordSystemDatasource;
}

export interface HeliosUserFilterConditionValue {
  conditionValueSource?: ConditionValueSource;
  staticValue?: string;
  staticValues?: string[];
  fromValue?: string;
  toValue?: string;
  systemDatasource?: HeliosRecordSystemDatasource;
  templateDataItemId?: number;
}

export interface HeliosUserFilterCondition {
  leftBracket: boolean;
  rightBracket: boolean;
  isBlank?: boolean | null;
  datasource: HeliosUserFilterConditionDatasource;
  leftLogicalOperator?: LogicalOperator;
  comparisonOperator: ComparisonOperator;
  value?: HeliosUserFilterConditionValue;
}

// Main user filter type
export interface HeliosUserFilter {
  id: string;
  name: string;
  isActive: boolean;
  isDefault: boolean;
  userId: string;
  userFilterType: EUserFilterType;
  userFilterAdministrationSectionType: EUserFilterAdministrationSectionType;
  templateId?: string;
  conditions?: HeliosUserFilterCondition[];
}

// Request types
export interface GetHeliosUserFiltersReq extends BasicFilter<null> {
  templateId: string;
  userId?: string;
  type?: EUserFilterType;
  administrationSectionType?: EUserFilterAdministrationSectionType;
}

export interface CreateHeliosUserFilterReq {
  name: string;
  conditions: HeliosUserFilterCondition[];
  isActive: boolean;
  isDefault: boolean;
  userId?: string; // Optional - backend extracts from JWT if not provided
  userFilterType: EUserFilterType;
  userFilterAdministrationSectionType?: EUserFilterAdministrationSectionType;
  templateId: string;
}

export interface UpdateHeliosUserFilterReq {
  id: string;
  name?: string;
  conditions?: HeliosUserFilterCondition[];
  isActive?: boolean;
  isDefault?: boolean;
}

export interface DeleteHeliosUserFilterReq {
  ids: string[];
}

// Response types
export interface GetHeliosUserFiltersRes extends BasePagedResponse {
  items: HeliosUserFilter[];
}
